



































































































import Vue from 'vue';
import DictMixin from '@/mixins/dict-mixin';
import SubjectServices from '@/services/subject';
import DimensionServices from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import SubjectForm6 from './subject-form-6.vue';
import RefData from '../dimension/ref-data.vue';
import MenuMixin from '@/mixins/menu-mixin';
@Component({
  components: { SubjectForm6, RefData }
})
export default class SubjectDetail extends mixins(DictMixin, MenuMixin) {
  subSrv = new SubjectServices();
  dimSrv = new DimensionServices();
  dimList: any = [];
  dimItemList: any = [];
  visible = false;
  id: any = 0;
  info = {};

  created() {
    this.id = this.$route.query.id;
    this.getDimList();
  }

  async getDimList() {
    this.dimList = await this.dimSrv.getEnableList();
    this.dimItemList = await this.dimSrv.getItemList();
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  subFieldList: any[] = [];
  subSyncDefs: any = {};
  inputdataConfig: any[] = [];
  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/subject/detail') return false;
    this.spinning = true;
    let res = await this.subSrv.getInfo(this.id);
    this.spinning = false;
    this.info = res.subDef;
    this.subFieldList = res.subFieldList;

    this.subFieldList.map(v => {
      if (v.fieldCategory !== '1' || v.refDimCode === '') return false;
      let dim = this.dimList.find((dim: any) => dim.dimCode == v.refDimCode);
      if (dim) Vue.set(v, 'refDimName', dim.dimName);
    });
    this.subSyncDefs = res.subSyncDefs;
    this.inputdataConfig = JSON.parse(this.subSyncDefs.syncConfig || '[]');
    this.subSyncDefs.jobConfig = JSON.parse(this.subSyncDefs.jobConfig);
    this.subSyncDefs.syncConfig = JSON.parse(this.subSyncDefs.syncConfig);
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
